import React, { useState } from 'react';
import classes from './Input.module.css';
import eyeDisableIcon from '../../../assets/icons/eye-disable.png';
import eyeIcon from '../../../assets/icons/eye.svg';

interface InputProps {
  placeholder: string;
  label: string;
  value: string;
  type: string;
  id: string;
  isSecure: boolean;
  textarea: boolean;
  errorText: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const Input: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  type,
  id,
  isSecure,
  textarea,
  errorText,
}: InputProps) => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const togglePassword = (e: any) => {
    e.preventDefault();
    setPasswordShown(!passwordShown);
    passwordType === 'text' ? setPasswordType('password') : setPasswordType('text');
  };
  return (
    <>
      <div className={classes.container}>
        <div className={classes.inputRow}>
          <div className={classes.inputContainer}>
            {!textarea && (
              <input
                className={classes.input}
                id={id}
                type={isSecure && isSecure ? passwordType : type}
                value={value}
                placeholder={label}
                onChange={onChange}
              />
            )}
          </div>
     
          {isSecure && (
            <button className={classes.iconBtn} type="button" onClick={togglePassword}>
              <img
                src={passwordType === 'password' ? eyeIcon : eyeDisableIcon}
                alt="Trulli"
                className={classes.icon}
              />
            </button>
          )}
        </div>
        {errorText && <span className="error-div">{errorText && errorText}</span>}
      </div>
    </>
  );
};

export default Input;
